export default {
  metaTitle: '商品评价',
  pageTitle: '店铺评价管理',
  all: '所有',
  unreplied: '未回复',
  replied: '已回复',
  sku: 'SKU#',
  reviewDetails: '评价详情',
  orderRating: '订单评分',
  deliverySpeed: '时效评分',
  Minute: '分',
  sellerService: '卖家服务态度',
  deliveryService: '物流服务',
  productRating: '商品评分',
  Evaluation: '商品评价内容',
  replyContent: '回复内容',
  inputPlaceholder1: '请输入您的回复',
  SKU: 'SKU#',
  listingId: 'Listing ID',
  commentId: '评论ID',
  title: '标题',
  userId: '用户ID',
  reviewDate: '评论时间',
  score: '评分值',
  withPicture: '有图',
  operation: '操作',
  checkDetails: '检查详情',
  selectSku_Listing: '请选择Sku或Listing！',
  cannotEmpty: '内容不能为空',
  moreThan_200word: '回复不能超过200个字符！'
}
